<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters" style="display: flex;justify-content: space-between;">
        <el-form :inline="true" label-position="left" class="form-item-200">
          <cargo-area
            country="CN"
            :province.sync="filter.province"
            :city.sync="filter.city"
            :district.sync="filter.district"
            :select-width="165"
            :label-width="'50'"
            style="display: inline-block"
          />
        </el-form>
        <el-form :inline="true" label-width="50px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_Name')">
            <el-input
              v-model="filter.name"
              :placeholder="$t('CargoMsg.Cargo_PlsInput') + $t('CargoMsg.Cargo_Name')"
              style="width: 165px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="onAdd()">{{ $t('common.btn.new') + $t('CargoMsg.Cargo_StreetTownship') }}</el-button>
        <!--        <el-button no="exportExcel" type="primary" @click="exportExcel">{{ $t('common.btn.exportExcel') }}</el-button>-->
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        config-module="101411"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>

    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>

    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="townDialog.visible"
      :title="townDialog.title"
      width="450px"
      style="font-size: 16px"
      :close-on-click-modal="false"
    >
      <div class="editDialog" style="padding: 10px 0 10px 0;">
        <el-form :inline="false" :disabled="!townDialog.isEdit" label-position="left" class="form-item-400">
          <cargo-area
            country="CN"
            :province.sync="townDialog.form.province"
            :city.sync="townDialog.form.city"
            :district.sync="townDialog.form.district"
            :label-width="'50'"
            :is-required="true"
            :select-width="310"
          />
        </el-form>
        <el-form :disabled="!townDialog.isEdit" label-position="left" class="form-item-200">
          <el-form-item :label="$t('CargoMsg.Cargo_Name')" label-width="50px" :required="true">
            <el-input v-model="townDialog.form.name" style="width: 310px" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="townDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import commerceEditDialog from '@/views/cargo/v0/Information/components/basicData/commerceEditDialog.vue'
import { DocumentManage } from '@/utils/commonUtil'
import cargoArea from '@/components/Cargo/Common/cargoArea'
import { getTownList, saveTown, delTown } from '@/api/basicData/town'

export default {
  name: 'Town',
  components: { commerceEditDialog, cargoAdvanceSelect, cargoArea },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      filter: {
        name: '',
        province: '',
        city: '',
        district: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [] // 去掉每列的菜单
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Name'),
          field: 'name',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Province'),
          field: 'province',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AdministrativeDivision, 'code', params.value, 'name')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_city'),
          field: 'city',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AdministrativeDivision, 'code', params.value, 'name')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_District'),
          field: 'district',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AdministrativeDivision, 'code', params.value, 'name')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Creator'),
          field: 'createdBy',
          colId: 'createdBy',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.DateOfCreation2'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UpdatePerson'),
          field: 'modifiedBy',
          colId: 'modifiedBy',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.DateModified'),
          field: 'dateModified',
          colId: 'dateModified',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Operation'),
          field: 'operation',
          suppressMenu: true,
          width: 140,
          cellRenderer: params => {
            const onView = this.documentManage.getPath('onView')
            const onEdit = this.documentManage.getPath('onEdit')
            const onDel = this.documentManage.getPath('onDel')
            return `<div>
                        <a onclick="${onView}('${params.data.uuid}')" style="color:#1F75D5;font-size:12px;">${this.$t('CargoMsg.Cargo_View')}</a>
                        <a onclick="${onEdit}('${params.data.uuid}')" style="color:#1F75D5;font-size:12px;">${this.$t('CargoMsg.Cargo_Edit')}</a>
                        <a onclick="${onDel}('${params.data.uuid}')" style="color:red;font-size:12px;">${this.$t('CargoMsg.Cargo_Delete')}</a>
                      </div>`
          }
        }
      ],
      rowData: null,
      documentManage: new DocumentManage(),
      townDialog: {
        visible: false,
        title: '',
        isEdit: false,
        form: {
          uuid: '',
          name: '',
          province: '',
          city: '',
          district: ''
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onView', function(value) {
      context.onView(value)
    })
    this.documentManage.set('onEdit', function(value) {
      context.onEdit(value)
    })
    this.documentManage.set('onDel', function(value) {
      context.onDel(value)
    })
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getTownList(self.filter).then(res => {
        self.rowData = res.data.list
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    onDel(uuid) {
      const self = this
      if (!uuid) {
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        delTown(uuid).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
        }).catch(() => {})
      })
    },
    onAdd() {
      this.showEditDialog(true, true, null)
    },
    onView(uuid) {
      this.showEditDialog(false, false, uuid)
    },
    onEdit(uuid) {
      this.showEditDialog(false, true, uuid)
    },
    async showEditDialog(isNew, isEdit, uuid = null) {
      if (isNew) {
        this.townDialog.form = {
          uuid: '',
          name: '',
          province: '',
          city: '',
          district: ''
        }
        this.townDialog.isEdit = true
        this.townDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_AdministrativeDivision')
        this.townDialog.visible = true
      } else {
        if (!uuid || uuid.length === 0) {
          return
        }
        const town = this.rowData.find(p => p.uuid === uuid)
        if (town) {
          this.townDialog.form = town
          this.townDialog.isEdit = isEdit
          const label = isEdit ? this.$t('CargoMsg.Cargo_EditTo') : this.$t('CargoMsg.Cargo_View')
          this.townDialog.title = label + this.$t('CargoMsg.Cargo_AdministrativeDivision')
          this.townDialog.visible = true
        }
      }
    },
    save() {
      const self = this
      const form = self.townDialog.form
      if (!form.province) {
        self.$message.warning(self.$t('CargoMsg.Cargo_Province') + self.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!form.city) {
        self.$message.warning(self.$t('CargoMsg.Cargo_city') + self.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!form.district) {
        self.$message.warning(self.$t('CargoMsg.Cargo_District') + self.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!form.name) {
        self.$message.warning(self.$t('CargoMsg.Cargo_Name') + self.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      const loading = getLoading()
      saveTown(form).then(res => {
        self.toQuery()
        self.townDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.townDialog.visible = false
      }).finally(() => loading.close())
    },
    exportExcel() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          self.$t('CargoMsg.Cargo_Name'),
          self.$t('CargoMsg.Cargo_Province'),
          self.$t('CargoMsg.Cargo_city'),
          self.$t('CargoMsg.Cargo_District'),
          self.$t('CargoMsg.Cargo_Creator'),
          self.$t('SeaExport.DateOfCreation2'),
          self.$t('CargoMsg.Cargo_UpdatePerson'),
          self.$t('CargoMsg.DateModified')
        ]
        const filterVal = ['name', 'province', 'city', 'district', 'createdBy', 'dateCreated', 'modifiedBy', 'dateModified']
        const data = self.formatJson(filterVal, rows)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'Town'
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
}
</script>

<style scoped lang="scss">
.el-dialog__title {
  font-size: 15px;
}
</style>
